import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IntlService } from '@progress/kendo-angular-intl';
import { PageBaseComponent } from './page-base.component';
import { AuthService, DatasourceService } from '@app/core/services';
import { NotificationService } from "@progress/kendo-angular-notification";
import { DialogService, DialogRef, DialogCloseResult } from "@progress/kendo-angular-dialog";
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';
import { Location } from '@angular/common';

@Component({
  selector: 'service-actions',  
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-form.css', './styles/styles-loading.css'],
  styles: [`
    form {
      padding: 0 15px 132px 15px;
    }
    .right {
      float: right; 
      position: inherit;
    }
    .title {
      color: #BEBEBE;
      padding-top: 8px;
    }
    .title span.right {
      color: black;
    }
  `],  
  template: `

    <div class="k-block k-block-full" *ngIf="loading">
      <kendo-loader [type]="'converging-spinner'" [size]="'medium'"></kendo-loader>
    </div>

    <div class="wrapper-route-0">

      <form novalidate [formGroup]="form">
        <div class="example-wrapper form-detail">        
          <div class="row" *ngIf="dataItem != null && dataItem?.id_service_status != 1">          
            <div class="col-field">
              <kendo-label text="Salida de servicio"></kendo-label>              
              <div style="background-color: #{{ dataItem.service_status_color }}; text-align: center; padding: 6px; color: white; margin-top: 8px;">
                {{ dataItem.service_status_name }}
              </div>
              <div class="title no-wrap">
                Fecha y hora de salida: <span class="right">{{ getDate(dataItem.output_date, true) }}</span>
              </div>
              <div class="title no-wrap">
                Grúa: <span class="right">{{ dataItem.crane_name }}</span>
              </div>
              <div class="title no-wrap">
                Operador: <span class="right">{{ dataItem.person_operator_name }}</span>
              </div>
              <div class="title no-wrap">
                Destino: <span class="right">{{ dataItem.place }}</span>
              </div>
              <div class="title no-wrap" *ngIf="dataItem.id_service_status == 2 || dataItem.id_service_status == 4">
                Fecha y hora de entrada: <span class="right">{{ getDate(dataItem.entry_date, true) }}</span>
              </div>
              <div class="title no-wrap" *ngIf="dataItem.id_service_status == 2">
                Forma de pago: <span class="right">{{ dataItem.payment_type_name }}</span>
              </div>
              <div class="title no-wrap" *ngIf="dataItem.id_service_status == 4">
                Cliente: <span class="right">{{ dataItem.customer_name }}</span>
              </div>
              <div class="title no-wrap" *ngIf="dataItem.id_service_status == 2 || dataItem.id_service_status == 4">
                Costo: <span class="right">{{ intl.formatNumber(dataItem.cost, "c2") }}</span>
              </div>
              <div class="title no-wrap" *ngIf="dataItem.id_service_status == 2 || dataItem.id_service_status == 4">
                Núm. de factura: <span class="right">{{ dataItem.invoice }}</span>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="dataItem==null || dataItem?.id_service_status == 1">
            <div class="col-field">
              <kendo-label text="Salida de servicio - {{ mode == 'CREATE' ? 'Nuevo': 'Editar' }}"></kendo-label>              
              <div *ngIf="dataItem!=null" style="background-color: #{{ dataItem.service_status_color }}; text-align: center; padding: 6px; color: white; margin-top: 8px;">
                {{ dataItem.service_status_name }}
              </div>
            </div>      
            <div class="col-field">
              <kendo-label text="Fecha y hora de salida:"></kendo-label>
              <kendo-textbox-container>
                <kendo-datepicker formControlName="output_date" [format]="'dd-MMM-yyyy HH:mm'"></kendo-datepicker>
              </kendo-textbox-container> 
              <div *ngIf="f.output_date.invalid && (f.output_date.dirty || f.output_date.touched)">                  
                <div *ngIf="f.output_date.errors">
                  <kendo-formerror *ngIf="f.output_date.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>              
            <div class="col-field">
              <kendo-label text="Grúa:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-dropdownlist formControlName="id_crane" [table]="'cranes'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </kendo-textbox-container> 
              <div *ngIf="f.id_crane.invalid && (f.id_crane.dirty || f.id_crane.touched)">                  
                <div *ngIf="f.id_crane.errors">
                  <kendo-formerror *ngIf="f.id_crane.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field">
              <kendo-label text="Operador:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-dropdownlist formControlName="id_person_operator" [table]="'persons_operators'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </kendo-textbox-container> 
              <div *ngIf="f.id_person_operator.invalid && (f.id_person_operator.dirty || f.id_person_operator.touched)">                  
                <div *ngIf="f.id_person_operator.errors">
                  <kendo-formerror *ngIf="f.id_person_operator.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>   
            <div class="col-field">
              <kendo-label text="Destino:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-autocomplete formControlName="place" [table]="'services_inventories'" [valueField]="'place'" [showAll]="true" controlTrim></dynamic-autocomplete>
              </kendo-textbox-container> 
              <div *ngIf="f.place.invalid && (f.place.dirty || f.place.touched)">                  
                <div *ngIf="f.place.errors">
                  <kendo-formerror *ngIf="f.place.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field">
              <kendo-label text="Observaciones:"></kendo-label>
              <kendo-textbox-container>
                <kendo-textarea formControlName="observations" [rows]="3"></kendo-textarea>
              </kendo-textbox-container> 
              <div *ngIf="f.observations.invalid && (f.observations.dirty || f.observations.touched)">                  
                <div *ngIf="f.observations.errors">
                  <kendo-formerror *ngIf="f.observations.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>        
          </div>
        </div>
      </form>

      <kendo-floatingactionbutton icon="arrow-left" themeColor="secondary" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'start', vertical: 'bottom' }" positionMode="fixed" (click)="goBack()"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="save" themeColor="info" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="onSave($event)" [disabled]='!form.valid && !loading' *ngIf="(dataItem == null || dataItem?.id_service_status == 1) && authService.hasPermission(['SALIDAS_SERVICIOS:EDITAR'])"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="trash" themeColor="error" [offset]="{ x: '78px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="delete()" *ngIf="mode == 'EDIT' && dataItem?.id_service_status == 1 && authService.hasPermission(['SALIDAS_SERVICIOS:ELIMINAR'])"></kendo-floatingactionbutton>      

      <kendo-floatingactionbutton icon="cancel" themeColor="error" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="cancel()" *ngIf="mode == 'EDIT' && dataItem?.id_service_status != 1 && authService.hasPermission(['SALIDAS_SERVICIOS:ELIMINAR'])"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="arrow-right" themeColor="success" [offset]="{ x: dataItem?.id_service_status == 1 ? '145px': '78px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="recepcion()" *ngIf="mode == 'EDIT' && dataItem?.id_service_status != 2 && dataItem?.id_service_status != 4 && authService.hasPermission(['SALIDAS_SERVICIOS:EDITAR'])"></kendo-floatingactionbutton>

    </div>

    <div kendoDialogContainer></div>

  `    
})
export class ServiceActionsComponent extends PageBaseComponent implements OnInit {
  
  public id: number = 0;

  public mode = 'CREATE';

  public table: string = 'services_inventories';

  public form!: FormGroup;

  public loading = false;

  public dataItem: any = null;

  public returnUrl: string = 'services';

  private sub: any;


  constructor(public authService: AuthService, protected router: Router, protected route: ActivatedRoute, protected service : DatasourceService, public intl: IntlService, private notificationService: NotificationService, private dialogService: DialogService, private location: Location) { 

    super(authService, router)

    let state = location.getState() as {returnUrl: string};
    if(state.returnUrl != null)
      this.returnUrl = state.returnUrl;
    // console.log(this.returnUrl);
    
  }

  //@Override
  protected getFormGroup(dataItem?: any): FormGroup {

    const tzDate = ZonedDate.fromUTCDate((dataItem) ? new Date(dataItem.output_date) : new Date(), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),  
      'output_date': new FormControl((dataItem) ?new Date(tzDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required),
      'place': new FormControl((dataItem) ? dataItem.place: '', Validators.required),
      'id_crane': new FormControl((dataItem) ? dataItem.id_crane: '', Validators.required),
      'id_person_operator': new FormControl((dataItem) ? dataItem.id_person_operator: 1, Validators.required),
      'id_service_status': new FormControl((dataItem) ? dataItem.id_service_status: 1),      
      'observations': new FormControl((dataItem) ? dataItem.observations: ''),
    });

  };

  ngOnInit() {

    // this.form = this.getFormGroup();
    // this.update();

    

    this.sub = this.route.data.subscribe(v => {
      // console.log(v);
      this.mode = v.mode;
      this.form = this.getFormGroup();
      if(this.mode == 'CREATE') {

      }
      else {
        let id = this.route.snapshot.paramMap.get('id');
        this.id = (id != null) ? parseInt(id): 0;

        // console.log(this.router.getCurrentNavigation());
        this.loading = true;

        this.service.getById(this.table, this.id)
          .subscribe(
            (result: any) => {
              // console.log(result);
              this.dataItem = result;

              this.loading = false;

              this.form = this.getFormGroup(result);
            },
            (error: any) => {
              console.log(error)
              // this.loading = false;
            });

      }

    });

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  protected getData(formGroup: FormGroup): Object {

    return Object.assign({}, formGroup.value, { 
      output_date: this.intl.formatDate(formGroup.value.output_date, "yyyy-MM-dd HH:mm"),
    });

  };

  public onDelete(): void {

    this.loading = true;

    this.service.removeRow(this.table, this.dataItem)
      .subscribe(
        (res: any) => {

          this.loading = false;

          const dialog: DialogRef = this.dialogService.open({
            title: "Éxito",
            content: `Se eliminó con éxito ${this.getMessage()}`,
            actions: [{ text: "Ok", primary: true }],
            width: '80%',
            // height: 200,
            // minWidth: 250,
          });
        
          dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                // console.log("close");
            }
            this.goBack()
          });

        },
        (error: any) => {
          console.log(error)
          // this.loading = false;
        });

  }

  public onSave(event: any): void {
  
    if(this.form.valid) {

      let data = this.getData(this.form);
      // console.log('data', data)

      this.loading = true;

      if(this.mode == 'CREATE'){
          // console.log(data);
        this.service.addRow(this.table, data) 
          .subscribe(
            (res: any) => {
              console.log("POST Request is successful: ", this.table, data, res);

              this.dataItem = res.data[0];

              this.loading = false;

              const dialog: DialogRef = this.dialogService.open({
                title: "Éxito",
                content: `Se registró con éxito ${this.getMessage()}`,
                actions: [{ text: "Ok", primary: true }],
                width: '80%',
                // height: 200,
                // minWidth: 250,
              });
            
              dialog.result.subscribe((result) => {
                if (result instanceof DialogCloseResult) {
                    // console.log("close");
                }
                this.goBack()
              });

            },
            (fail: any) => {        
              console.log("Error", fail);
              // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
            }
          ); 
      }
      else {
        this.service.updateRow(this.table, data) 
          .subscribe(
            (res: any) => {
              console.log("PUT Request is successful: ", this.table, data);
              // console.log("mode = " + this.mode);
              // this.save.emit({mode: this.mode, dataItem: res.data[0]});

              // this.notificationService.show({
              //     content: `Se registró con éxito el costo de grúa de ${this.intl.formatNumber(res.data[0].cost_crane, "c2")}`,
              //     hideAfter: 1000,
              //     position: { horizontal: "center", vertical: "top" },
              //     animation: { type: "fade", duration: 400 },
              //     type: { style: "success", icon: true },
              //   });

              // this.update();

              this.loading = false;

              const dialog: DialogRef = this.dialogService.open({
                title: "Éxito",
                content: `Se editó con éxito ${this.getMessage()}`,
                actions: [{ text: "Ok", primary: true }],
                width: '80%',
                // height: 200,
                // minWidth: 250,
              });
            
              dialog.result.subscribe((result) => {
                if (result instanceof DialogCloseResult) {
                    // console.log("close");
                }
                this.goBack()
              });

            },
            (fail: any) => {        
              console.log("Error", fail);
              // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
            }
          ); 
      }

    }
    
  }

  public delete() {

    const dialog: DialogRef = this.dialogService.open({
      title: "Confirmar",
      content: `¿Esta seguro que desea eliminar ${this.getMessage()}?`,
      actions: [{ text: "No", primary: true }, { text: "Sí" }],
      width: '80%',
      // height: 200,
      // minWidth: 250,
    });
  
    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
          // console.log("close");
      }
      else {
        // console.log(result);
        if(result.text == 'Sí') {
          // this.save();
          this.onDelete();
        }
      }
    });

  }

  public goBack() {

    this.router.navigate([`/${this.returnUrl}`]);

  }

  public getMessage() {

    return `la salida de servicio de ${this.intl.formatDate(this.dataItem.output_date, "yyyy-MM-dd HH:mm")}, ${this.dataItem.crane_name}, ${this.dataItem.person_operator_name}. ID: [${this.dataItem.id}]?`;

  }

  public cancel() {

    const dialog: DialogRef = this.dialogService.open({
      title: "Confirmar",
      content: `¿Esta seguro que desea cancelar la recepción de ${this.getMessage()}?`,
      actions: [{ text: "No", primary: true }, { text: "Sí" }],
      width: '80%',
      // height: 200,
      // minWidth: 250,
    });
  
    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
          // console.log("close");
      }
      else {
        // console.log(result);
        if(result.text == 'Sí') {
          // this.save();
          this.onCancel();
        }
      }
    });    

  }

  public onCancel(){

    let data = {
      id: this.dataItem.id,
      entry_date: null,
      id_payment_type: null,
      cost: null,
      invoice: '',
      id_service_status: 1,
      observations: this.f.observations.value,
    }

    this.loading = false;

    this.service.updateRow(this.table, data) 
      .subscribe(
        (res: any) => {
          console.log("PUT Request is successful: ", this.table, data);

          const dialog: DialogRef = this.dialogService.open({
            title: "Éxito",
            content: `Se canceló con éxito ${this.getMessage()}`,
            actions: [{ text: "Ok", primary: true }],
            width: '80%',
            // height: 200,
            // minWidth: 250,
          });
        
          dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                // console.log("close");
            }
            this.goBack()
          });

        },
        (fail: any) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      ); 
      
  }

  public recepcion() {

    this.router.navigate(['/service_reception/' + this.dataItem.id]);

  }

  public getDate(s: string, show_hour: boolean = false): String {  

    if (s == null || s == '') {
      return '';
    }
    else {
      const tzDate = ZonedDate.fromUTCDate(new Date(s), environment.timezone);
      return this.intl.formatDate(tzDate, `dd-MMM-yyyy${(show_hour) ? ' HH:mm': ''}` );
    }
    
  }

}